import type { ReactNode } from 'react'

type AdminPageShellProps = {
  title: string
  icon: ReactNode
  children: ReactNode
  className?: string
}

type AdminPanelSectionProps = {
  title: string
  description?: string
  action?: ReactNode
  children: ReactNode
  className?: string
}

export function AdminPageShell({ title, icon, children, className = '' }: AdminPageShellProps) {
  return (
    <div className={`admin-content-shell admin-content-shell--full ${className}`.trim()}>
      <header className="admin-content-header">
        <div className="admin-content-header__icon">{icon}</div>
        <div className="admin-content-header__copy">
          <h2>{title}</h2>
        </div>
      </header>

      {children}
    </div>
  )
}

export function AdminPanelSection({
  title,
  description,
  action,
  children,
  className = '',
}: AdminPanelSectionProps) {
  return (
    <section className={`admin-panel admin-panel--team ${className}`.trim()}>
      <div className="admin-panel__header admin-panel__header--team">
        <div>
          <h3>{title}</h3>
          {description ? <p>{description}</p> : null}
        </div>
        {action}
      </div>

      {children}
    </section>
  )
}
